import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  BannerConfig,
  BannerPosition,
} from '@g99-product-web-ui/shared-interface-lib';
import { closeIcon, infoToastrIcon } from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'g99-lib-generic-banner',
  templateUrl: './generic-banner.component.html',
  styleUrl: './generic-banner.component.scss',
  standalone: false,
})
export class GenericBannerComponent {
  @Input() public isVisible = true;
  @Input() public config!: BannerConfig;

  @Output() public closeClick = new EventEmitter<void>();
  @Output() public linkClick = new EventEmitter<void>();

  protected closeIcon = closeIcon;
  protected isAnimating = false;
  protected infoIcon = infoToastrIcon;

  constructor(private readonly _router: Router) {}

  protected handleLinkClick(event: Event): void {
    event.preventDefault();

    if (this.config.navigateTo) {
      this._router.navigate([this.config.navigateTo]);
    }

    this.linkClick.emit();
  }

  protected get positionClass(): string {
    const position = this.config.position || BannerPosition.FIXED;
    return `setup-banner--${position}`;
  }

  protected closeBanner(): void {
    this.isAnimating = true;

    setTimeout(() => {
      this.isVisible = false;
      this.isAnimating = false;
      this.closeClick.emit();
    }, 300);
  }
}
